import { VerifyProductResult } from '../types/apis'
export const dataURLtoFile = (dataurl: any, filename: any) => {
  if (dataurl && dataurl !== 'data:,') {
    const arr = dataurl.split(',')
    const mime = arr[0].match(/:(.*?);/)[1]
    const bstr = atob(arr[1])
    let n = bstr.length
    const u8arr = new Uint8Array(n)

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n)
    }

    return new File([u8arr], filename, { type: mime })
  } else {
    console.log('invalid image dataurl')
  }
}

export const redirectToUrl = (url: string, isLiveStream = false) => {
  if (isLiveStream) {
    window.open(url, '_blank', 'noopener,noreferrer');
  } else {
    window.location.href = url;
  }
}

// export const checkIfDenso = (productId: string): boolean =>
//   [checkProduct(productId).isDensoMexico, checkProduct(productId).isDensoColombia].some(
//     (isDenso) => isDenso,
//   )
export const checkIfDenso = (productId: string): boolean => false;

export const redirectToDensoResultPage = ({
  result,
  productId,
}: {
  result?: VerifyProductResult | undefined
  productId?: string | undefined
}) => {
  interface RedirectUrl {
    genuine: {
      [key: string]: string
    }
    fake: {
      [key: string]: string
    }
  }

  const redirectUrl: RedirectUrl = {
    genuine: {
      denso_mexico: 'https://densoautopartes.com/producto_autentico',
      denso_colombia: 'https://densoautopartes.com/producto_autentico',
      P_Denso_De_Co_QX_5OU: 'https://densoautopartes.com/producto_autentico_inyector',
      P_Denso_De_Co_QX_PBS: 'https://densoautopartes.com/producto_autentico_inyector',
      P_Denso_De_Co_QX_MBU: 'https://densoautopartes.com/producto_autentico_inyector',
      P_Denso_De_Co_QX_2SL: 'https://densoautopartes.com/producto_autentico_inyector'
    },
    fake: {
      denso_mexico: 'https://densoautopartes.com/falsificacion_producto',
      denso_colombia: 'https://densoautopartes.com/falsificacion_producto',
      P_Denso_De_Co_QX_5OU: 'https://densoautopartes.com/producto_no_original_inyector',
      P_Denso_De_Co_QX_PBS: 'https://densoautopartes.com/producto_no_original_inyector',
      P_Denso_De_Co_QX_MBU: 'https://densoautopartes.com/producto_no_original_inyector',
      P_Denso_De_Co_QX_2SL: 'https://densoautopartes.com/producto_no_original_inyector'
    },
  }

  if (productId) {
    switch (result) {
      case 'GENUINE':
        window.location.href = redirectUrl.genuine[productId] ?? 'https://densoautopartes.com/producto_autentico'
        break
      case 'POTENTIAL_FAKE':
        window.location.href = redirectUrl.fake[productId] ?? 'https://densoautopartes.com/falsificacion_producto'
        break
    }
  }
}
export function getApiBaseUrl(): string {
  const env = getEnvironmentFromDomain();
  
  switch (env) {
    case 'dev':
      return 'https://d.api.enncrypto.com';
    case 'qa':
      return 'https://q.api.enncrypto.com';
    case 'stage':
      return 'https://s.api.enncrypto.com';
    case 'prod':
      return 'https://api.enncrypto.com';
    default:
      return 'https://d.api.enncrypto.com';
  }
}
export function getN8NApiBaseUrl(): string {
  const env = getEnvironmentFromDomain();
  
  switch (env) {
    case 'dev':
      return 'https://d-workflow.ops.ennteract.com';
    case 'qa':
      return 'https://d-workflow.ops.ennteract.com';
    case 'stage':
      return 'https://workflow.ops.ennteract.com';
    case 'prod':
      return 'https://workflow.ops.ennteract.com';
    default:
      return 'https://d-workflow.ops.ennteract.com';
  }
}
export function getEnvironmentFromDomain(): any {
  try {
    const env = process.env.APP_ENV;
    console.log("ENV from process.env", env)
    if (env) {
      switch (env) {
        case "development":
          return "dev";
        case "test":
          return "qa";
        case "production":
          return "prod";
        default:
          return env;
      }
    } else {
      const hostname = window.location.hostname.toLowerCase();
      if (
        hostname.includes("d.vyu.ennteract.com") ||
        hostname.includes("d.api.enncrypto.com")
      ) {
        return "dev";
      }
      if (
        hostname.includes("q.vyu.ennteract.com") ||
        hostname.includes("q.api.enncrypto.com")
      ) {
        return "qa";
      }

      if (
        hostname.includes("s.vyu.ennteract.com") ||
        hostname.includes("s.api.enncrypto.com")
      ) {
        return "stage";
      }

      if (
        hostname.includes("vyu.ennteract.com") ||
        hostname === "api.enncrypto.com"
      ) {
        return "prod";
      }

      return "dev";
    }
  } catch (error) {
    console.error("Error detecting environment:", error);
    return "dev";
  }
}

export const preloadImage = (url) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      console.log('Image preloaded successfully:', url);
      resolve(img);
    };
    img.onerror = (error) => {
      console.warn('Failed to preload image:', url, error);
      reject(error);
    };
    img.src = url;
    
    // Also add to document head for additional caching
    const link = document.createElement('link');
    link.rel = 'preload';
    link.href = url;
    link.as = 'image';
    link.type = 'image/webp';
    document.head.appendChild(link);
  });
};

export async function getDeviceModel() {
    try {
        const hints = await navigator?.userAgentData?.getHighEntropyValues([
            'model',
            'platformVersion',
            'fullVersionList',
            'architecture',
            'bitness'
        ]);
        
        const deviceModel = hints.model || '';
        
        localStorage.setItem('deviceModel', deviceModel);
        localStorage.setItem('deviceHints', JSON.stringify(hints));
        console.log('deviceModel', deviceModel)
        return deviceModel;
        
    } catch (error) {
        console.log('High entropy hints not supported:', error);
    }
}